var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.707 12.7071C19.0975 12.3166 19.0975 11.6834 18.707 11.2929L10.707 3.29289C10.3164 2.90237 9.68327 2.90237 9.29274 3.29289C8.90222 3.68342 8.90222 4.31658 9.29274 4.70711L16.5856 12L9.29274 19.2929C8.90222 19.6834 8.90222 20.3166 9.29274 20.7071C9.68327 21.0976 10.3164 21.0976 10.707 20.7071L18.707 12.7071Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/Chevron-Right.71be4b2f7d769c80a7e0c25ac98fcd9f.svg";
export { ForwardRef as ReactComponent };